import React, { useState, useRef } from 'react';
import { FaSearch } from 'react-icons/fa';
import Form from 'react-bootstrap/Form';
import { LinkContainer } from 'react-router-bootstrap';
import FormControl from 'react-bootstrap/FormControl';

const PtSearch = ({ search }) => {
  const [patient, setPatient] = useState();
  const ptInput = useRef();

  const capturePatient = (e) => {
    console.log('capture:', e.target.value);
    setPatient(e.target.value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    console.log('onSubmit:patient:', patient);
    var setPt = patient;
    setPatient('');
    ptInput.current.value = '';
    search(setPt);
  };

  return (
    <Form inline onSubmit={onSubmit}>
      <FormControl
        type="text"
        placeholder="Patient Number"
        className="mr-sm-2 ml-3"
        onChange={capturePatient}
        ref={ptInput}
      />
      <LinkContainer to="/patient">
        <FaSearch type="submit" onClick={onSubmit} />
      </LinkContainer>
    </Form>
  );
};

export default PtSearch;
